import React, { useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

// davidBillings: {
//   src: '/images/backgrounds/optimized/david-billings-KCEwOduK8ck-unsplash.webp',
//   lowResSrc: '/images/backgrounds/optimized/david-billings-KCEwOduK8ck-unsplash.small.webp',
//   credit: 'David Billings',
//   link: 'https://unsplash.com/@dav_billings?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge',
//   color: '#FFFFFF',
//   background: '#1B3137',
// },

const BlurLoadImage = ({ lowResSrc, src, onLoad, className = '', style = {}, ...props }) => {
  const [highResImageLoaded, setHighResImageLoaded] = useState(false);

  const highResImage = useRef();

  const internalOnLoad = useCallback(
    (e) => {
      setHighResImageLoaded(true);
      if (onLoad) onLoad(e);
    },
    [setHighResImageLoaded, onLoad],
  );

  const highResStyles = {
    ...style,
    opacity: 0,
  };

  const lowResStyles = {
    opacity: 1,
    filter: 'blur(16px)',
    clipPath: 'inset(0)',
    display: 'block',
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    backfaceVisibility: 'hidden',
    transform: 'translate(-50%, -50%) scale(1.42)' /* order is important here */,
  };

  if (highResImageLoaded) {
    lowResStyles.opacity = 0;
    lowResStyles.transition = 'opacity ease-in-out 100ms';
    highResStyles.opacity = 1;
  }

  return (
    <>
      <img
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        alt=""
        className={className}
        onLoad={internalOnLoad}
        ref={highResImage}
        style={highResStyles}
        src={src}
      />
      <img
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        alt=""
        className={`${className} overlay`}
        style={lowResStyles}
        src={lowResSrc}
      />
    </>
  );
};

BlurLoadImage.defaultProps = {
  onLoad: null,
  className: '',
  style: {},
};

BlurLoadImage.propTypes = {
  lowResSrc: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

export default BlurLoadImage;
